// extracted by mini-css-extract-plugin
module.exports = {"block":"NotFound_block__39Ynn","table":"NotFound_table__1KF1c","title404":"NotFound_title404__QTWoX","title":"NotFound_title__2pAET"};